import React, { useContext, useState, useEffect } from 'react'
import Loader from '../../../components/Loader'
import { menuItemObj } from '../../../constants'
import { Box } from '../../../designSystem'
import { get, post } from '../../../lib/api'
import { handleNewEventLog } from '../../../lib/utils/events'
import { AccountContext } from '../../../providers/accountProvider'
import { actionWhiteButton, ArrowWhite, BookAction, ctaBox } from '../style'

function ActionButtons({
  bookDetails,
  history,
  isNonIndianAndNonUSUser,
  viewApplication,
}) {
  const { isUnlockProcessing, setUnlockProcessing} = useState(false)
  const { user } = useContext(AccountContext)
  const [isPublishLoading, setIsPublishLoading] = useState(false)
  const isPublished =
    bookDetails?.status === 'published' || bookDetails?.status === 'approved'
  const isNotApplied = bookDetails?.application_status === 'not_applied'
  const isCreated = bookDetails?.application_status === 'created'
  const isOngoing = bookDetails?.application_status === 'ongoing'
  const isEligible = bookDetails?.application_status === 'eligible'
  const isPending = bookDetails?.application_status === 'pending'
  const isRejected = bookDetails?.application_status === 'rejected'
  const isTerminated = bookDetails?.application_status === 'termination'
  const isCompleted = bookDetails?.application_status === 'completion'
  const isUpdated = bookDetails?.application_status === 'updated'
  const isApproved = bookDetails?.application_status === 'approved'
  const isDisabled = bookDetails?.status === 'disabled'
  const publishTime = bookDetails?.publish_time
  const isDraft = bookDetails?.status === 'draft'
  const isLanguageNotAllowedForWBP = !['hindi', 'tamil', 'english'].includes(
    bookDetails.language
  )
  const isWBPBlocked =
    isPublished &&
    !(isPending || isApproved || isRejected) &&
    isLanguageNotAllowedForWBP

  const isMobile = window.screen.width < 600

  useEffect(() => {
    if (bookDetails?.daily_tracker?.chapter_missed) {
      handleNewEventLog(
        'home',
        `writer_home_add_todays_chapter_cta_viewed`,
        {
          route: window.location.pathname + window.location.search,
          module_name: 'home_novel_module',
          button: 'add_todays_chapter'
        },
        user,
        bookDetails
      )
    }
    if(isPublished && isNotApplied && bookDetails.word_count < bookDetails.application_threshold){
      handleNewEventLog(
        'home',
        `writer_home_complete_${bookDetails.application_threshold}_words_cta_viewed`,
        {
          route: window.location.pathname + window.location.search,
          module_name: 'home_novel_module',
          button: 'complete_30k_words'
        },
        user,
        bookDetails
      )
    }
    if(!isPublished && isNotApplied && !isDisabled && !publishTime){
      handleNewEventLog(
        'home',
        `writer_home_publish_your_novel_cta_viewed`,
        {
          route: window.location.pathname + window.location.search,
          module_name: 'home_novel_module',
          button: 'publish_your_novel'
        },
        user,
        bookDetails
      )
    }
  },[])

  const handlePublishClick = async () => {
    if (isPublishLoading) return
    handleNewEventLog('home','writer_home_publish_your_novel_cta_clicked',{route : window.location.pathname + window.location.search, button : 'publish_your_novel'}, user, bookDetails)
    setIsPublishLoading(true)
    let getDetailsBeforePublish = false
    // TODO: disucss if throw error and not procees if details fetch api fails,
    // which might lead to wrong flag sent to chapter open page
    const detailsRes = await get('/content_api/book.novel_details', {
      params: {
        book_id: bookDetails.book_id,
        view: 'dashboard',
        is_novel: 1,
      },
    })
    const { results } = detailsRes
    const hasRequiredBookDetails =
      results.image_url &&
      results.description &&
      results.book_title &&
      results.category_obj &&
      results.category_obj.topic_id
    if (!hasRequiredBookDetails) {
      getDetailsBeforePublish = true
    }
    get('/content_api/book.chapters_by_status', {
      params: {
        page_no: 1,
        book_id: bookDetails.book_id,
        status: 'draft',
        view: 'dashboard',
        is_novel: 1,
      },
    })
      .then((response) => {
        setIsPublishLoading(false)
        const firstChapter = response.results.chapters[0] || {}
        const { chapter_id } = firstChapter
        if (chapter_id) {
          history.push(
            `${menuItemObj.novels}/edit-chapter/${
              bookDetails.book_id
            }?chapter_id=${chapter_id}&proceed_to_details=${
              getDetailsBeforePublish ? '1' : ''
            }&redirect_to_home=1`
          )
        } else {
          history.push(`${menuItemObj.novels}/id/${bookDetails.book_id}?tab=draft`)
        }
      })
      .catch((error) => {
        setIsPublishLoading(false)
        throw error
      })
  }

  const handleUnlockReward = () => {
    if (isUnlockProcessing) return
    const { program_id } = bookDetails
    if (!program_id) return
    setUnlockProcessing(true)
    post('/content_api/book.rewards_unlock?is_novel=1', {
      data: {
        program_id,
      },
    })
      .then(() => {
        setUnlockProcessing(false)
        // resetAfterUnblock()
      })
      .catch((error) => {
        setUnlockProcessing(false)
        throw error
      })
  }

  const handleTodayChapter = () => {
    if (bookDetails?.daily_tracker?.chapter_missed) {
      handleNewEventLog(
        'home',
        `writer_home_add_todays_chapter_cta_clicked`,
        {
          route: window.location.pathname + window.location.search,
          module_name: 'home_novel_module',
          button: 'add_todays_chapter'
        },
        user,
        bookDetails
      )
    }
    history.push(
      `${menuItemObj.novels}/id/${bookDetails?.book_id}?tab=draft`
    )
  }

  return (
    <>
      <Box {...ctaBox}>
        {!isPublished && (isNotApplied || isCreated) && !isDisabled && !publishTime && (
          <BookAction onClick={handlePublishClick} enabled={1}>
            {!isPublishLoading ? (
              <>
                {bookDetails?.is_novel === 2
                  ? 'Publish Your Series'
                  : 'Publish Your Novel'}{' '}
                {isMobile && <ArrowWhite />}
              </>
            ) : (
              <Loader invertColor inline size="sm" />
            )}
          </BookAction>
        )}
        {!isDraft &&
          (isNonIndianAndNonUSUser ||
            isWBPBlocked ||
            (isPublished &&
              isPending &&
              bookDetails?.word_count >=
                (bookDetails?.application_threshold || 30000))) && (
            <BookAction
              onClick={() =>
                history.push(
                  `${menuItemObj.novels}/id/${bookDetails?.book_id}?tab=draft`
                )
              }
              enabled={1}
            >
              Add New Chapter {isMobile && <ArrowWhite />}
            </BookAction>
          )}
        {/* remove below button condition for Our Business Logic Condition */}
        {!isLanguageNotAllowedForWBP &&
          !isNonIndianAndNonUSUser &&
          isPublished &&
          ((isNotApplied && !bookDetails?.is_eligible) ||
            (isPending &&
              bookDetails?.word_count <
                (bookDetails?.application_threshold || 30000)) ||
            isCreated) && (
            <BookAction
              onClick={() =>
                {
                  handleNewEventLog(
                    'home',
                    `writer_home_complete_30k_words_cta_clicked`,
                    {
                      route: window.location.pathname + window.location.search,
                      module_name: 'home_novel_module',
                      button: `complete_${bookDetails.application_threshold}_words`
                    },
                    user,
                    bookDetails
                  )
                  history.push(`${menuItemObj.novels}/id/${bookDetails.book_id}?tab=draft`)
                }
              }
              enabled={1}
            >
              {`Complete ${bookDetails?.application_threshold} words`}
              {isMobile && <ArrowWhite />}
            </BookAction>
          )}
        {!isMobile &&
          isPublished &&
          isPending &&
          bookDetails?.word_count >=
            (bookDetails?.application_threshold || 30000) && (
            <Box
              {...actionWhiteButton}
              onClick={() => viewApplication(bookDetails?.book_id)}
            >
              View Application
            </Box>
          )}
        {isPublished && isApproved && (
          <BookAction
            onClick={() => (isUnlockProcessing ? null : handleUnlockReward())}
            enabled={1}
          >
            {!isUnlockProcessing ? (
              <>
                Accept and Unlock Rewards
                <ArrowWhite />
              </>
            ) : (
              <Loader invertColor inline size="sm" />
            )}
          </BookAction>
        )}

        {isPublished &&
          (isRejected || isUpdated || isTerminated || isCompleted) && (
            <BookAction
              enabled={1}
              onClick={() => history.push('/shows/novels/?open-new=1')}
            >
              {bookDetails?.is_novel === 2
                ? 'Create New Series'
                : 'Create New Novel'}{' '}
              {isMobile && <ArrowWhite />}
            </BookAction>
          )}
        {isEligible && (
          <BookAction
            enabled={1}
            onClick={handleTodayChapter}
          >
            {bookDetails?.daily_tracker?.chapter_missed
              ? 'Add Today’s Chapter'
              : 'Add New Chapter'}
          </BookAction>
        )}
        {isOngoing && (
          <BookAction
            enabled={1}
            onClick={handleTodayChapter}
          >
            {bookDetails?.daily_tracker?.chapter_missed
              ? 'Add Today’s Chapter'
              : 'Add New Chapter'}
            <ArrowWhite />
          </BookAction>
        )}
      </Box>
    </>
  )
}

export default ActionButtons
